export let zhMessages={

  // 2020.8.24 clinic 增加
  "Raw data":"数据",
  "Data Export":"导出数据",
  "Data Export Settings":"导出数据设置",
  "Select data to export":"导出数据选择",
  "Bolus":"大剂量",
  "Basal":"基础量",
  "Events":"事件",
  "Device Settings":"设备设置",
  "BG Export":"指尖血糖",

  // 2020.3.17 增加
  "country_region":"国家/地区",

  //
  "privacy_policy_and_terms_of_use":"隐私政策和服务协定",
  "privacy_confirm_text":"我们最近更新了<a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>隐私政策</a>和<a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>服务协定</a>。请仔细阅读，同意并接受全部条款后再使用EasyView</p>",
  "privacy_confirm_disagree":"不同意",
  "privacy_confirm_accept":"接受",

  "title":"EasyView Personal",
  "title1":"EasyView Pro",
  "user":"邮箱",
  "password":"密码",
  "remember":"记住密码",
  "forget":"忘记密码？",
  "sign in":"登录",
  "login":"登录",
  "sign up now":"立即注册",
  "apply":"立即申请账号",
  "contact us":"联系我们",
  "Privacy Policy":"隐私政策",
  "Terms of Use":"服务协议",
  "copyright":"2021，上海移宇科技有限公司，保留所有权利。",

  "chooseLang":"选择国家/地区和语言",
  "asia":"亚洲",
  "europe":"欧洲",
  "middleEast":"中东",

  "applyHcp":"申请HCP账号",
  "sign up":"注册",
  "Patient":"患者",
  "Caregiver":"监护人",
  "Email":"邮箱/用户名",
  "Mobile":"手机",
  "Enter email":"输入邮箱地址",
  "Enter mobile":"输入手机号",
  "Verification":"验证码",
  "Invitation":"邀请码",
  "full name":"输入真实姓名",
  "Enter pass":"输入密码",
  "org":"组织机构",
  "Register":"注册",
  "createAccount":"创建账户",
  "send":"发送",
  "agree":"我已阅读并同意此Medtrum的 ",
  "privacy":"隐私政策",
  "and" :"及 ",
  "use":"服务协议",
  "errtip1-1":"您的邮箱地址将会成为您的用户名，",
  "errtip1-2":" 请输入有效的邮箱地址",
  "errtip2":"请输入正确的手机号",
  "errtip3":"验证码输入错误",
  "errtip4":"邀请码错误",
  "errtip5":"未输入姓名",
  "errtip6":"你的密码必须不少于6位",
  "errtip7":"请输入您的组织机构",

  "errp1":"密码必须由至少三种字符组成:",
  "errp2":"大写字母、小写字母、数字或特殊字符",
  "errp3":"密码长度为6~20个字符",
  "errp4":"密码不能使用用户名",
  "errp5":"不能有三个以上连续的数字(如:123,321)",
  "errp6":"不能有三个以上连续的字母(如:abc,cba)",
  "errp7":"不能包含空格",

  "Find account":"找回密码",
  "Enter username":"请输入用户名",
  "Next":"下一步",
  "Cancel":"取消",
  "Back":"返回",
  "Enter veri":"请输入验证码",
  "Create new":"创建新密码",
  "Verify notice":"请输入您邮箱/手机中Medtrum公司发送的验证码",
  "Create new notice":"请输入6位新密码",
  "New pass" :"新密码",
  "Completed":"完成",
  "Created":"新密码已创建.",
  "Login Now":"立即登录",

  "Delete":"删除",
  "New Patient":"添加患者",
  "Add Patient":"查找患者",
  "Filter":"筛选",
  "Name":"姓名",
  "Gender":"性别",
  "Age":"年龄",
  "Type":"糖尿病类型",
  "Duration":"病龄",
  "Connections":"账号创建者",
  "UploadTime":"上传时间",
  "Year":"年",
  "Years":"年龄",
  "Month":"月",
  "Month2":"月",
  "Months":"月",
  "Invite":"邀请",
  "Invited":"已邀请",
  "All":"全部",
  "Female":"女性",
  "Male":"  男",
  "Not Set":"未填写",
  "Type 1":"类型 1",
  "Type 2":"类型 2",
  "Gestational":"妊娠糖尿病",
  "Prediabetes":"糖尿病前期",
  "LADA":"成人隐匿性免疫性糖尿病",
  "Apply":"保存",
  "addP":"添加患者",
  "newP":"新建患者",
  "findP":"查找患者",
  "disUn":"糖尿病类型 未填写",
  "ageUn":"未填写年龄",
  "genUn":"未填写性别",
  "GDRNF":"未填写",
  "GDRF":"女",
  "GDRM":"男",
  "女":"男性",

  "DBTNF":"未填写",
  "DBT1":"类型 1",
  "DBT2":"类型 2",
  "DBTLADA":"LADA",
  "DBTPRE":"前期",
  "DBTGEST":"DBTGEST",
  "前期":"前期",
  "beFore":"前期",
  "MODY":"其他",

  "No selection":"未填写",
  "unspecif":"未填写",
  "register":"患者",
  "hcp":"医生",

  "BG":"血糖值",
  "CARB":"食物",
  "INS":"胰岛素注射",
  "EXR":"运动",
  "OTR":"其他",
  "HBA1C":"HbA1c",
  "DOSE":"药物",
  "URINEK":"尿酮",
  "HEL":"HEL",
  "OTR1":"其他",
  "Loading":"加载中",

  "home":"首页",
  "pID":"患者编号",
  "fullName":"姓名",
  "gender":"性别",
  "height":"高",
  "weight":"体重",
  "cm":"厘米",
  "kg":"千克",
  "birthday":"出生日期",
  "disType":"糖尿病类型",
  "disDate":"确诊日期",
  "Address":"地址",
  "Postcode":"邮编",
  "Inpatient":"住院信息",
  "Yes":"是",
  "No":"否",
  "Pno":"住院编号",
  "Bno":"床位编号",
  "create":"创建",
  "Telephone":"座机",

  "enterU":"输入用户名（邮箱/手机号）",
  "search":"搜索",
  "noU":"未输入用户名",
  "searchR":"搜索结果",
  "uername":"用户名",
  "alias":"昵称",
  "remove":"移除",
  "viewG":"查看图表",
  "sendR":"发送请求",
  "rSent":"请求已发送",
  "cancelR":"取消申请监护的患者",
  "VcodeTip1":"验证码已发送到 ",
  "VcodeTip2":"中，请等待一分钟，若仍然未收到，请点击",
  "VcodeTip3":"重试",
  "Entercode":"输入验证码",
  "Getcode":"获取验证码",

  "messages":"消息",
  "profile":"个人信息",
  "sign out":"退出",
  "changeP":"修改密码",
  "connection":"联系人",

  "myP":"个人信息",
  "Portrait":"头像",
  "Profession":"职业",
  "DPRONF":"未填写",
  "DPROENDOCRIN":"内分泌医师",
  "DPRODIABTRA":"糖尿病护理教育者",
  "DPRONURSE":"护理医师",
  "DPRODIATIT":"营养师",
  "DPROOTR":"其他医疗服务人员",
  "Organization":"组织机构",
  "Bio":"简介",
  "save":"保存",
  "oldPa":"旧密码",
  "newPa":"新密码",
  "RePa":"确认密码",
  "forgetY":"忘记密码",
  "applyM":"应用",
  "oldErr":"旧密码错误。",
  "EntTheSame":"再次输入新密码。",
  "EnterOld":"输入旧密码",

  "pList":"患者列表",
  "connections":"患者列表",
  "settings":"设置",
  "monitor":"实时监控",
  "graphs":"报告",
  "events":"事件",
  "records":"病程记录",
  "qPrint":"快速打印",

  "sensorIn":"血糖信息",
  "timeOfLaRead":"最近血糖更新时间",
  "tranSn":"发射器序列号",
  "status":"状态",
  "sensorLife":"血糖探头剩余使用时间",
  "lastSenorRead":"最近血糖读数",
  "TranBattery":"发射器电量",
  "sg":"血糖",
  "alert":"告警",
  "target":"目标范围",
  "hypo":"低限",
  "sensorGlucose":"血糖读数",
  "calib":"校准",
  "newSen":"新探头",
  "warm":"初始化",
  "InsulinPump":"胰岛素泵",
  "timeOfLaPump":"最近一次泵数据更新时间",
  "pumpSN":"泵体控制器序列号",
  "ReserviorLife":"储药贴剩余时间",
  "InsulinLeft":"胰岛素剩余量",
  "basal":"基础量",
  "bolus":"大剂量",
  "totalBasal":"基础量总量",
  "lastBolus":"最近大剂量",
  "activeInsulin":"活性胰岛素",
  "totalBolus":"大剂量总量",
  "tampBasal":"临时基础量",
  "normalBolus":"正常大剂量",
  "extendBolus":"扩展大剂量",
  "manualStop":"手动暂停",
  "autoStop":"自动暂停",
  "auto suspend":"自动暂停",
  "stop":"输注停止",
  "newPatch":"新储药贴",
  "tempBasal":"临时基础量",
  "N":"正",
  "E":"扩",
  "CN1":"组正",
  "CE":"组扩",

  "staticSettings":"报告设置",
  "dataSource":"数据源",
  "unit":"单位",
  "glucoseTarget":"血糖目标范围",
  "overall":"总计",
  "Hypoglycemia":"低于3.1mmol/L（56mg/dL）",
  "timePeriod":"时间段",
  "postMeal":"餐后分析",
  "Breakfast":"早餐",
  "Lunch":"中餐",
  "Dinner":"晚餐",
  "night":"夜间",
  "Before":"前",
  "After":"后",
  "Low":"低限",
  "High":"高限",
  "From":"开始",
  "To":"结束",
  "Hours":"小时",
  "Reset":"恢复默认设置",
  "RealTime":"实时",
  "uploaded":"上传",
  "sensor":"血糖探头",
  "pdmSN":"手持机序列号",
  "startTime":"开始时间",
  "endTime":"结束时间",
  "uploadTime":"上传时间",
  "pdm":"手持机",
  "Uploaded":"上传",
  "Patch Pump":"贴片泵",
  "overLapp":"时间段重叠",
  "showAlert":"显示告警",

  "dashboard":"综合报表",
  "dboard_glucose_statistics":"统计",
  "dboard_glucose":"指尖血糖",
  "dboard_cgm":"动态血糖",
  "dboard_insulin":"胰岛素",
  "dboard_carbs":"食物",
  "dboard_exercise":"运动",
  "dboard_glucose_avg":"平均值",
  "dboard_cgm_avg":"平均值",
  "dboard_insulin_avg":"平均每天输注的胰岛素",
  "dboard_carbs_avg":"平均每天摄入量",
  "dboard_exercise_avg":"平均每天运动时间",
  "dboard_sd":"标准方差",
  "dboard_num":"次数",
  "dboard_num_days":"# days",
  "dboard_statistics":"统计",
  "dboard_BG":"血糖值",
  "dboard_BG_calibration":"BG/校准（每天）",
  "dboard_SG":"动态血糖值",
  "dboard_AUC_high":"AUC高 >",
  "dboard_AUC_low":"AUC低 <",
  "dboard_highest_value":"最高价值",
  "dboard_lowest_value":"最低价值",

  "dboard_pump":"泵",
  "dboard_avg_daily_dose":"平均每天输注的胰岛素",
  "dboard_SD":"标准方差",
  "dboard_daily_basal":"每日基础量",
  "dboard_daily_bolus":"每日大剂量",
  "dboard_avg_bolus_num":"平均每天输注大剂量次数",
  "dboard_avg_suspend_time":"平均暂停时间",
  "dboard_avg_reservoir_usage":"储药贴平均寿命",
  "dboard_days":"days",

  "dboard_manual_bolus":"手动大剂量（数量/次数）",
  "dboard_normal":"-正常",
  "dboard_extend":"-扩展",
  "dboard_combo":"-组合",

  "dboard_bolus_calculator":"大剂量向导（数量/次数）",
  "dboard_food_bolus":"-食物大剂量",
  "dboard_corr_bolus":"-校正大剂量",
  "dboard_override_add":"-向上调整(+)",
  "dboard_override_sub":"-向下调整(-)",

  "dboard_report":"综合报表报告",

  "daily":"每日总结",
  "date":"日期",
  "print":"打印",
  "carbs":"食物",
  "exercise":"运动",
  "heavy":"剧烈",
  "Medium":"中度",
  "Light":"轻度",
  "dailyReport":"每日总结报告",
  "devices":"设备",
  "tran":"发射器",
  "pumpBase":"泵体控制器",
  "HbA1c":"糖化血红蛋白",
  "statics":"统计",
  "glucose":"血糖",
  "item":"项",
  "BG1":"指尖血糖",
  "SG1":"血糖",
  "avgSD":"平均值(mmol/L)±标准差",
  "avgSD1":"平均值±标准差",
  "min":"最小值",
  "max":"最大值",
  "ofRead":"读数",
  "ofHypo":"低血糖次数/持续时间",
  "ofAlert":"告警次数",
  "insulin":"胰岛素",
  "insulin2":"胰岛素",
  "totalDose":"全天输注总量",
  "foodBolus":"食物大剂量",
  "Food+coor":"食物和校正大剂量",
  "calibBolus":"校正大剂量",
  "durationStop":"暂停输注时间(分钟)",
  "ofPumpAlert":"泵告警次数",
  "ofMeal":"进餐次数",
  "totalExerTime":"运动总时间",
  "exerNum":"运动次数",
  "avgInten":"平均强度",
  "target1":"目标范围",
  "high1":"高",
  "low1":"低",
  "BG Reading":"指尖血糖读数",

  "dayByday":"多日浏览",
  "dayBydayRe":"多日总结报告",
  "period":"时间段",

  "sensorOverlay":"血糖叠加图",
  "set":"设置",
  "setPeriod":"设置时间段",
  "Weekdays":"工作日",
  "Weekends":"周末",
  "Mon":"星期一",
  "Tue":"星期二",
  "Wed":"星期三",
  "Thur":"星期四",
  "Thu":"星期四",
  "Fri":"星期五",
  "Sat":"星期六",
  "Sun":"星期日",
  "Average":"平均值",
  "sensorOlRe":"血糖叠加图报告",
  "Avg":"平均值",
  "±SD":"±标准差",
  "ofhypo":"低血糖次数",
  "Everyday":"每天",

  "TrendAna":"趋势分析",
  "TrendRe":"趋势分析报告",
  "sensorGlu":"血糖探头读数",
  "ofBGtest":"指尖血糖读数（次数）",
  "Basics":"基本统计",
  "static":"统计",
  "Med":"中位数",
  "med":"中位数",
  "Q1":"1/4分位",
  "Q3":"3/4分位",
  "Q11":"1/4分位数",
  "Q31":"3/4分位数",
  "IQR":"四分位距",
  "SD":"标准差",
  "CV":"变异系数",
  "SE1":"均值标准误差",
  "distri":"分布",
  "stab":"稳定性",
  "#high":"#偏高",
  "#low":"#偏低",
  "aucBelow":"低限线下积分",
  "aucAbove":"高限线下积分",
  "bgRead":"指尖血糖读数",
  "total":"总量",
  "ofBolus":"大剂量次数",
  "avgBolus":"大剂量平均值",
  "Dura1":"运动（分）",
  "Avg/Total":"平均值/总计",
  "high":"高",
  "low":"低限",
  "#hypo":"低血糖次数",
  "ofExer":"运动次数",

  "logbook":"日志",
  "dailyTotal":"全天总量",
  "High Glucose":"血糖高",
  "Low Glucose":"血糖低",
  "No Active Patch":"无激活储药贴",
  "Missed Meal":"错过用餐时间",
  "Multiple BG Readings":"多个指尖血糖读数",
  "Stop Patch":"储药贴终止",
  "Others":"其他",
  "Other Events":"其他事件",
  "logRe":"日志报告",

  "DeviceSetting":"设备设置报告",
  "Insulin Pump":"胰岛素泵",
  "MaxBasalRate":"基础量最大值",
  "BasalPatterns":"基础量程序",
  "Selected Basal Pattern":"激活的基础量程序",
  "Maximum Bolus":"大剂量最大值",
  "Combo/Extended Bolus":"组合/扩展大剂量",
  "BG Reminder":"指尖血糖提醒",
  "Bolus Increment":"大剂量步长",
  "Bolus Calculator":"大剂量向导",
  "Active Insulin Time":"活性胰岛素",
  "IC Ratios":"胰岛素食物比",
  "Insulin Sensitivity":"胰岛素灵敏度",
  "BG Target":"目标血糖",
  "Bolus Reminder":"大剂量提醒",
  "CGM":"动态血糖",
  "CGM System":"动态血糖系统",
  "Glucose Unit":"血糖单位",
  "Glucose Limits":"血糖门限",
  "Predicitive Alerts":"血糖异常预测告警",
  "Rate Alerts":"血糖变化异常告警",
  "type":"类型",
  "time":"时间",
  "data":"数据",
  "Rate":"速率",
  "Calibration Reminder":"校准提醒",
  "Calibration Repeat":"校准重复告警",
  "Snooze":"重复告警间隔",
  "Audio Options":"声音选项",
  "Confidence Reminder":"指令响应提示",
  "Backlight":"背光",
  "Sec":"秒",
  "Alarm Clock":"闹钟",
  "Patch Expiration":"储药贴过期告警",
  "Sensor Expiration":"探头过期告警",
  "Hourly Max":"每小时最大输注量",
  "Daily Max":"每天最大输注总量",
  "Low Reservoir":"低储药量告警",
  "Low Suspend":"低血糖暂停输注",
  "Predictive Low Suspend":"预测低血糖暂停输注",
  "Rise":"上升",
  "Fall":"下降",
  "Auto Off":"自动暂停输注",
  "Standard":"标准",
  "Exercise":"锻炼",
  "Holiday":"假日",
  "ProgramA":"程序A",
  "ProgramB":"程序B",
  "--":"--",
  "Insulin":"胰岛素",

  "SUSA":"自动暂停输注告警",
  "SUSHM":"超出每小时最大量暂停输注",
  "SUSDM":"超出每天最大量暂停输注",
  "SUSLSG":"低血糖暂停输注",
  "SUSPLSG":"预测低血糖暂停输注",
  "Pump Restarted":"贴片泵重启",
  "Meter BG Now":"立即输入指尖血",
  "Sensor Exp in 2 Hours":"探头2小时内过期",
  "Sensor Exp in 6 Hours":"探头6小时内过期",
  "Sensor Exp in 30 Min":"探头30分钟内过期",
  "Sensor Calibration Error":"探头校准错误",
  "Sensor Error":"无血糖读数",

  "Device Settings Report":"设备设置报告",
  "Device Settings at":"设备设置时间",
  "24h Total":"24小时总量",
  "Start":"开始",
  "Combo/Ext Bolus":"组合/扩展大剂量",
  "Time Format":"时间制",
  "Device Options（CGM System)":"动态血糖系统",
  "Device Options（Insulin Pump)":"胰岛素泵系统",
  "Dispay Settings (Screen)":"显示（屏幕）",
  "Dispay Settings (Backlight)":"显示（背光）",
  "Graph Range":"血糖趋势图显示",
  "Range":"范围",
  "Repeat":"模式",
  "Glucose Alerts":"血糖告警",
  "Alert Silence":"血糖告警静音",

  "Create":"添加",
  "Event Filter":"筛选",
  "HbA1c1":"糖化血红蛋白",
  "Urine Ketone":"尿酮",
  "Injection":"胰岛素注射",
  "Other":"其他",
  "Event Type":"事件类型",
  "Details":"详情",
  "Notes":"备注",
  "Source":"来源",
  "edit":"编辑",
  "Action":"操作",
  "EventReport":"事件汇总报告",
  "By Date":"按日期",
  "By Category":"按项目",
  "Event Summary":"事件汇总",
  "No data":"无数据",
  "No1":"无",
  "data1":"数据",
  "#":"次数",
  "BG Summary":"指尖血糖统计",
  "Carbs Summary":"食物统计",
  "Injection Summary":"胰岛素注射统计",
  "Exercise Summary":"运动统计",
  "Input Notes":"输入备注",

  "Profile":"个人信息",
  "Complications":"并发症",
  "Concomitant diseases":"伴发病",
  "Suggestion":"建议",
  "Coronary heart disease":"冠心病",
  "High blood lipids":"高血脂",
  "High blood pressure":"高血压",
  "Kidney disease":"肾病",
  "Neuropathy":"神经病变",
  "Obesity":"肥胖症",
  "Peripheral arterial disease":"外周动脉疾病",
  "Retinopathy":"视网膜病变",
  "Smoking addiction":"吸烟者",
  "Enter date":"输入日期",
  "Enter suggestion":"输入建议",
  "Enter Notes":"输入备注",
  "Select":"选择",
  "Prescription":"药方",
  "Medicine":"药物类型",
  "Dose":"用量",
  "Enter medicine":"输入药物类型",
  "Enter dose":"输入药量",
  "Enterdis":"输入并发症",
  "Add note":"输入备注",
  "Add Content":"最大长度为1000字符。",
  "Other suggestions":"其他建议",
  "OK":"确定",
  "HCP":"医护人员",
  "Content":"内容",
  "Records Report":"病程记录报告",

  "Quick Print":"快速打印",
  "Quick Print Settings":"快速打印设置",
  "Select duration":"选择时间间隔",
  "One Week":"一周",
  "One Month":"一月",
  "One Quarter":"一个季度",
  "End date":"截止日期",
  "Yesterday":"昨天",
  "Last Sunday":"上周日",
  "Last Saturday":"上周六",
  "Last Day of Last Month":"上个月最后一天",
  "Last Day of Last Quarter":"上个季度最后一天",
  "Customized":"设置",
  "Week Filter":"星期删选",
  "Select reports to print":"选择需要打印的报告",
  "Daily Summary":"每日总结",
  "Day By Day Overview":"多日总结",
  "Sensor Overlay":"血糖叠加图",
  "Trend Analysis":"趋势分析",
  "Logbook":"日志",
  "Device Settings Review":"设备设置",
  "createReport":"创建报告",

  "Segment Analysis":"分段分析",
  "Sensor Glucose Profile":"动态血糖",
  "# of Boluses":"大剂量次数",
  "Bolus Insulin":"大剂量",
  "Basal Pattern":"基础量程序",
  "Segment Analysis Report":"分段分析报告",
  "Avg Glucose":"血糖平均值",
  "Below":"低于",
  "In Target Range":"目标范围",
  "Coefficient of variation":"变异系数",
  "% Time CGM Active":"CGM激活时间百分比",
  "est_a1c_t1":"估算糖化血红蛋白：",
  "est_a1c_t2":"基于动态血糖值计算所得",
  "est_a1c_t3":"说明：估算的糖化血红蛋白值不能替代实验室所测量的值",

  "acceptTip":" 已授权监护。",
  "cancelTip":" 已取消对您的授权，如需远程监护，请重新申请。",
  "rejectTip":" 拒绝了您的申请。",
  "Read":"阅读",

  "Connection":"患者",
  "connections1":"联系人",
  "Add Connection":"添加患者",
  "SG":"血糖值",
  "Active Insulin":"活性胰岛素",
  "Stop following":"停止监护",
  "Enter username (email)":"输入用户名（邮箱/手机号）",
  "Search results":"搜索结果",
  "Send request":"发送请求",
  "View graphs":"查看图表",
  "Agree":"同意",
  "Deny":"拒绝",
  "Remove":"移除",
  "Cancel Requset":"取消申请监护的患者",
  "Remark":"备注",

  "Patient Profile":"患者信息",

  "Warm up":"初始化",
  "Monitoring":"正常监控中",
  "Transmitter Error":"发射器故障",
  "Sensor Failure":"血糖探头失败",
  "Sensor Expired":"血糖探头过期",
  "Lost Sensor":"血糖探头丢失",
  "Not Calibrated":"未校准",
  "Calibrating":"校准中",
  "Calibration Needed":"校准过期",
  "Calibration Error":"校准错误",
  "Charging Battery":"充电中",
  "Battery Charged":"充电完成",

  "To be filled":"等待灌药",
  "Filled with insulin":"已灌药",
  "Priming":"充盈中",
  "Priming completed":"充盈已完成",
  "Inserting needle":"正在注针过程中",
  "Patch activated":"注针已完成",
  "Delivering Basal":"正在输注基础量",
  "Exceeds Max 1 Hour Delivery":"超出每小时最大量暂停输注",
  "Exceeds Max TDD":"超出每天最大量暂停输注",
  "Suspend":"用户手动暂停输注",
  "Occlusion Detected":"储药贴堵塞",
  "Patch Expired":"储药贴过期",
  "Empty Reservoir":"储药贴空",
  "Patch Error":"储药贴故障",
  "Pump Base Error":"泵控制器故障",
  "Patch Battery Depleted":"电池没电",
  "Magnetic sensor not calibrated":"磁传感器未校准",

  "On":"开启",
  "on":"开启",
  "Off":"关闭",
  "off":"关闭",

  "CORONARY_HEART_DISEASE":"冠心病",
  "HIGH_BLOOD_LIPIDS":"高脂血",
  "HIGH_BLOOD_PRESSURE":"高血压",
  "KIDNEY_DISEASE":"肾病",
  "NEUROPATHY":"神经病变",
  "OBESITY":"肥胖症",
  "PERIPHERAL_ARTERIAL_DISEASE":"外周动脉疾病",
  "RETINOPATHY":"视网膜病变",
  "SMOKING_ADDICTION":"吸烟者",

  "saveTip":"保存成功!",
  "changePaTip":"密码修改成功",
  "enterEmTip":"请输入您的邮箱/手机",
  "verErrTip":"验证码输入错误",
  "chooseEventTip":"选择需要打印的事件",
  "chooseDataTip":"选择要打印的数据",
  "dateWrongTip":"截止日期不能小于起始日期",
  "infoWrongTip":"信息未填写完成",
  "createdSuccssTip":"创建成功",
  "selectData":"选择要保存的数据",

  "acceSu":"已接受的联系人申请",
  "acceEr":"添加新联系人失败",
  "rejeSu":"已拒绝的联系人申请",
  "rejeEr":"拒绝联系人申请失败",

  "userNotExist":"用户名不存在",
  "Password incorrect":"密码错误。",
  "UserType incorrect":"账号类型错误",
  "registSuccess":"您的账号已成功创建。",
  "registFailed":"注册新账号失败。",
  "sentSuccess":"发送消息成功",
  "sentFailed":"发送消息失败",

  "Input error":"输入错误",

  "deletePtip":"确定需要删除这些患者吗？",
  "deleteEvents":"请确认是否需要删除这些事件？",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis":"请确认是否需要删除这个事件？",
  "confirm":"确定",
  "deleteSuccess":"已删除",
  "deleteFailed":"删除项失败",
  "modifySuccess":"修改成功",
  "modifyFailed":"修改失败",
  "createSuccess":"创建成功",
  "createFailed":"创建成功",
  "editSuccess":"编辑成功",
  "editFailed":"编辑失败",
  "Time overlapped":"选择的时间段重叠。",

  "stopFollow":"你确定要停止监护此患者吗？",
  "CancelTip1":"请确认是否需要删除此联系人？",

  "Warning":"提示",
  "agreeConnect":"点击“同意”后，联系人将会看到您的血糖数据、胰岛素泵数据及个人相关信息。",
  "denyConnect":"请确认是否拒绝联系人申请？",
  "deleteConnect":"请确认是否需要删除此联系人？如果确认删除，此联系人将无法远程查看您的血糖数据、胰岛素泵数据及个人相关信息。",

  "Choose the events to print":"选择要打印的事件",
  "tryAgain":"重试",
  "username and password is required":"请输入用户名和密码",
  "A name is required":"请输入姓名",
  "username is required":"请输入用户名",
  "The date choose wrong":"时间选择错误",
  "Date no more than 14 days":"所选的日期不能操过14天",

  "CancelTip":"请确认是否需要删除此联系人？",
  "removeConnect":"删除成功",

  "dateErr1":"日期选择范围不能超过90天.",
  "dateErr2":"截止日期不能小于起始日期",

  "Not Filled":"未填写",
  "Today":"今天",
  "duration":"病龄",
  "interval":"Interval",
  "7 days":"7天",
  "14 days":"14天",
  "30 days":"30 天",
  "90 days":"90 天",
  "g":"克",

  "Sound+Vibrate":"声音+振动",
  "Sound":"声音",
  "Vibrate":"振动",
  "Silent":"免打扰",
  "1":"一次",
  "2":"每天",
  "noMes":"无消息",
  "noConnect":"无联系人",
  "Customize":"设置",
  "GB":"United Kingdom",
  "CN":"China",
  "FR":"France",
  "DD":"Germany",
  "DE":"Germany",
  "SE":"Sweden",
  "AU":"Australia",
  "HKF":"Hongkong",
  "HU":"Hungary",
  "IT":"Italy",
  "NL":"Netherlands",
  "Nor":"Norway",
  "PT":"Portugal",
  "ES":"Spain",
  "TR":"Turkey",

  "Jan":"一月",
  "Feb":"二月",
  "Mar":"三月",
  "Apr":"四月",
  "May":"五月",
  "Jun":"六月",
  "Jul":"七月",
  "Aug":"八月",
  "Sep":"九月",
  "Oct":"十月",
  "Nov":"十一月",
  "Dec":"十二月",
  "ApplyTip":" 申请监护您的数据.",
  "noReadings":"无血糖读数",

  "daop_A6_system":"A6 Touchcare System",
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",
  "daop_TY012_TY015":"TY012/TY015",
  "daop_easysense":"EasySense",
  "daop_delete_data":"删除数据",
  "daop_uploaded_data":"已上传数据",
  "daop_uploaded_data_text":"数据来源于EasyTouch移动应用程序或EasyView iPad移动应用",
  "daop_realtime_data":"实时数据",
  "daop_realtime_data_text":"数据来源于EasySense移动应用程序",

  "ins_unit":"(U)",
  "ins_unit2":"U",
  "basal_unit":"（U/H）",
  "basal_unit2":"U/H",

  "dump_last":"Dump End",

  // 告警
  "Alerts_Patch_Battery_Low":"储药贴电量低",
  "Alerts_Patch_Battery_Depleted":"储药贴没电", // update
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"储药量低", // update
  "Alerts_Empty_Reservoir":"储药贴空",
  "Alerts_Patch_Expiration_Advisory":"储药贴过期预警",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"储药贴过期", // update
  "Alerts_Patch_Error":"储药贴故障",
  "Alerts_Pump_Base_Error":"泵控制器故障",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"储药贴堵塞", // update
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"超过每天最大输注量", // update
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"超过每小时最大输注量",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"预测低血糖暂停输注", // update
  "Alerts_Low_Suspend":"低血糖暂停输注",
  "Alerts_Auto_Off":"自动暂停输注", // update

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"血糖探头丢失", // update
  "Alerts_Transmitter_Battery_Low":"发射器电量低",
  "Alerts_Charge_Transmitter":"发射器需充电",
  "Alerts_Sensor_Error":"无血糖读数", // update
  "Alerts_Transmitter_Error":"发射器故障",
  "Alerts_Sensor_Calibration_Error":"探头校准错误",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"血糖探头失败",
  "Alerts_Sensor_Calibration_Reminder":"探头校准提醒",
  "Alerts_Meter_BG_Now":"立即输入指尖血",
  "Alerts_Sensor_Exp_in_6_Hours":"探头6小时内过期",
  "Alerts_Sensor_Exp_in_2_Hours":"探头2小时内过期", // update
  "Alerts_Sensor_Exp_in_30_Min":"探头30分钟内过期",
  "Alerts_Sensor_Expired":"血糖探头过期", // update
  "Alerts_Rapid_Rise":"上升快",
  "Alerts_Rapid_Fall":"下降低",
  "Alerts_High_Predicted":"预期血糖高",
  "Alerts_Low_Predicted":"预期血糖低",
  "Alerts_High_Glucose":"血糖高", // update
  "Alerts_Low_Glucose":"血糖低", // update
  "Alerts_Below_3.1_mmol/L":"低于3.1mmol/L",
  "Alerts_Transmitter_Battery_Low_2":"发射器电量低",

  "Alerts_PDM_Battery_Low":"手持机电量低",
  "Alerts_Replace_Battery":"手持机立即充电",

  // Alert页面
  "Alert":"告警",
  "Alerts":"告警",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"泵",
  //"CGM":"CGM",
  "alert_Time":"时间",
  "alert_Type":"类型",

  "Out Of Range": "超出范围",

  "t1221_Auto_Mode":"自动模式总结",
  "t1221_Time_in_Auto_Mode":"自动模式时长",
  "t1221_Average_SG_SD":"平均血糖±标准差",
  "t1221_Time_in_Target_Range":"目标血糖比例",
  "t1221_Time_above_Range":"高血糖比例",
  "t1221_Time_below_Range":"低血糖比例",
  "t1221_Auto_Basal_per_day":"自动基础量(每天)",
  "t1221_Auto_Bolus_per_day":"自动大剂量(每天)",
  "t1221_Auto_Mode_Exits":"自动模式退出",
  "t1221_No_Sensor_readings":"无血糖读数",
  "t1221_Max_Delivery":"最大输注",
  "t1221_Min_Delivery":"最小输注",

  "t1222_autoModeBasal":"自动模式基础量",
  "t1222_autoModeCorrBolus":"自动模式校正大剂量",
  "t1222_autoSnack":"自动零食",
  "t1222_autoBreakfast":"自动早餐",
  "t1222_autoLunch":"自动午餐",
  "t1222_autoDinner":"自动晚餐",
  "t1222_autoExercise":"自动运动",
  "t1222_Snack":"零食",
  "t1222_auto_basal":"自动基础量",
  "t1222_auto_bolus":"自动大剂量",
  "t1222_Auto_Mode":"自动模式",
  "t1222_Time_in_Auto_Mode":"自动模式时长",
  "t1222_Avg_SD":"平均值(mmol/L)±标准差",
  "t1222_Target_Range":"目标血糖次数",
  "t1222_Above_Range":"高血糖次数",
  "t1222_Below_Range":"低血糖次数",
  "t1222_Auto_Mode_Exits":"自动模式退出次数",

  "t0805_User_Management":"用户管理",
  "t0805_Patient_Management":"患者管理",
  "t0805_Operation_History":"操作历史",
  "t0805_User_List":"用户列表",
  "t0805_User":"用户",
  "t0805_Time":"时间",
  "t0805_Operation_Type":"操作类型",
  "t0805_Back":"返回",
  "t0805_Add":"增加",
  "t0805_Delete":"删除",
  "t0809_Add_User":"添加用户",
  "t1028_Pattern_C":"程序C",
  "t1028_Pattern_D":"程序D",
  "t1029_Auto_meal_bolus":"自动餐食大剂量",
  "t1029_Auto_mode_correction_bolus":"自动模式校正大剂量",
  "t1029_Sick":"生病",
  "t1029_Auto_Mode_Feature":"自动模式功能",
  "t1029_Target_SG":"目标血糖",
  "t1029_Auto_Meal_Handling":"自动餐食调整",
  "t1029_Total_Daily_Dose":"每日输注总量",
  "t1029_Pump_Light":"泵控制器灯",
  "t1029_Alerts_for_Hypo":"低血糖报警",
  "t1102_Out_of_Range":"泵通信超过范围",
  "t1102_Command_Reminder":"命令提醒",
  "t1102_Alarms_Alerts_on_APP":"贴片泵报警",
  "t1102_Alarms_on_App":"APP中高优先级报警",
  "t1102_Alerts_on_App":"APP低优先级报警",
  "t1102_Factory_Calibration":"免校准",
  "t1102_Alerts_for_Low":"血糖低报警",
  "t1102_Alerts_for_High":"血糖高报警",
  "t1102_Alerts_for_Others":"其他报警",
  "t1102_Adjustment":"调整",
  "t1102_Suggested":"建议输注值",
  "t1103_Glucose":"血糖",
  "t1103_CGM":"动态血糖",
  "t1103_Insulin":"胰岛素",
  "t1103_Carbs":"食物",
  "t1103_Exercise":"运动",
  "t1103_Min_Max":"最小值/最大值",
  "t1103_Target_Range":"目标范围",
  "t1103_Overall_Tine_In_Range":"总计: 时间范围",
  "t1103_Basal":"基础量",
  "t1103_Bolus":"大剂量",
  "t1103_Basal_Bolus":"基础量&大剂量",
  "t1103_Auto_Mode_Time_In_Range":"自动模式: 时间范围",
  "t1103_Time_below_range":"低血糖比例",
  "t1103_Time_above_range":"高血糖比例",
  "t1103_Time_in_target_range":"目标血糖比例",
  "t1103_Incorrect_Password":"密码输入错误，还剩$1次尝试机会，请确认登录密码是否正确。",
  "t1103_Incorrect_locked":"密码错误次数超过限制，账户已被锁定，请$1分钟后再试。",
  "t1104_The_data_is_from":"数据来源于EasySense移动应用程序或EasyPatch移动应用程序",
  "t1104_Privacy_Policy":"隐私政策和服务协定",
  "t1104_updated_privacy_policy":"我们最近更新了隐私政策和服务协定。请仔细阅读，同意并接受全部条款后再使用EasyView。",
  "t1104_Disagree":"不同意",
  "t1104_Agree":"同意",
  "t1105_Upload_History":"上传历史",
  "t1105_Delete_Data":"删除数据",
  "t1105_Target_Range":"目标范围",
  "t1105_request_to_view_your_data":"$1请求查看您的数据。",
  "t1105_Recent_Updates":"最近更新",
  "t1108_No_data":"无数据",
  "t1108_Pump_Bash_SN":"泵体控制器序列号",
  "t1108_Transmitter_SN":"发射器序列号",
  "t1112_Normal_Glucose":"正常血糖",
  "t1112_Manual_Bolus_or_Modified_Bolus":"手动大剂量或修改过的大剂量",
  "t1112_Auto_Mode_Started":"自动模式开始",
  "t1112_Auto_Mode_Exit":"自动模式退出",
  "t1112_Normal_Bolus":"正常大剂量",
  "t1112_Extended_Bolus":"扩展大剂量",
  "t1112_Combo_Bolus":"组合大剂量",
  "t1112_Carbs":"碳水化合物量",
  "t1112_Glucose":"血糖",
  "t1112_BG":"指尖血糖",
  "t1112_Audio":"声音",
  "t1112_Tone":"告警声音",
  "t1112_Audio_Options":"声音选项",
  "t1112_Weight_Unit":"体重单位",
  "t1112_Height_Unit":"身高单位",
  "t1112_Not_available":"无法使用",
  "t1112_Number":"序号",
  "t1112_days":"天数",
  "t1112_min":"分钟",
  "t1113_days":"天",
  "t1215_Security":"安全",
  "t1215_MFA":"多重身份验证",
  "t1215_Enter_verification_code":"输入验证码",
  "t1215_Multi_factor_ON":"多重身份认证已开启。验证码已发送至 $1， 请提交验证码。",
  "t1215_Verification_code_incorrect":"验证码错误",
  "t1215_Show_Glucose_Value":"显示血糖值",
  "t1221_enter_verification_code":"请输入发送到$1的6位验证码。",
  "t1221_Verification_Success":"验证成功",
  "t1222_We_will_only_process":"未获得您的同意，我们不会通过Medtrum应用程序或网站处理您的医疗数据。",
  "t1222_If_you_are_under_years":"未满16周岁的未成年人必须获得父母或者监护人的同意才可以注册账号。",
  "t1221_register_cn":"你有权利选择不上传任何设备数据到应用程序，在此情况下，其他人无法访问数据。如果选择不注册Medtrum账号登录应用程序/网站，您的医疗数据只记录并保存在设备中。",
  "t1221_register_eu":"如果您选择注册Medtrum账户并使用账户访问Medtrum的应用程序，该应用程序上记录的医疗数据将被上传至Medtrum在欧洲的服务器，并保存2年。你有权利选择不上传任何设备数据到应用程序，在此情况下，其他人无法访问数据。如果选择不注册Medtrum账号登录应用程序/网站，您的医疗数据只记录并保存在设备中。",
  "t1221_register_follow":"未获得您的同意，我们不会通过Medtrum 应用程序或网站处理您的医疗数据。",
  "t1222_Terms_of_Use":"移宇科技的使用条款",
  "t1222_Privacy_Policy":"移宇科技的隐私政策",
  "t1222_Create_Account":"创建账号",
  "t1222_Back":"返回",
  "t1222_Verify_your_account":"验证您的账号",
  "t1222_please_check_your_account":"我们将会把验证码发送到$1，请检查您的账号。",
  "t1222_I_Agree_to":"我同意$1",
  "t1223_Invalid_Verification_Code":"无效的验证码，请重试。",
}

//export default zhMessages



// WEBPACK FOOTER //
// ./src/lang/zh.js